import './game-news-list.styles.scss';
import linkifyHtml from 'linkify-html';
import { format } from 'date-fns';
import { getMessagePostedTs, sortGameMessages } from './game-news.utils';
import ToggleInput from '@/components/SHARED/toggle-input/toggle-input.component';

// onEdit / onDelete / onToggleActive are only passed on the manager side;
// without them the list is read-only.
const GameNewsList = ({
  gameMessages,
  onEdit,
  onDelete,
  onToggleActive
}) => {

  const messages = sortGameMessages(gameMessages);

  if (messages.length === 0) {
    return (
      <div className='game-news-list'>
        <div className='g-list-item center-col meta'>No news has been posted yet.</div>
      </div>
    )
  }

  return (
    <div className='game-news-list'>
      {
        messages.map(m => (
          <div key={m.id} className='g-list-item news-item'>
            <div className='news-item-head'>
              <div>
                {
                  (m.title) &&
                  <div className='headline'>{m.title}</div>
                }
                <div className='meta'>
                  Posted {format(new Date(getMessagePostedTs(m)), "Pp")}
                  {
                    (m.ts_created && m.ts !== m.ts_created) &&
                    <span> &middot; Edited {format(new Date(m.ts), "Pp")}</span>
                  }
                </div>
              </div>
              {
                (onEdit || onDelete || onToggleActive) &&
                <div className='news-item-buttons'>
                  {
                    (onToggleActive) &&
                    <div className='active-toggle' title="Active items pop up on players' home pages">
                      <ToggleInput
                        contentKey={m.id}
                        checked={m.active === true}
                        saveData={(id, checked) => onToggleActive(m, checked)} />
                      <span className={`meta ${m.active === true ? 'is-active' : ''}`}>
                        {m.active === true ? 'Active' : 'Inactive'}
                      </span>
                    </div>
                  }
                  {
                    (onEdit) &&
                    <button className='g-button small-btn' onClick={() => onEdit(m)}>Edit</button>
                  }
                  {
                    (onDelete) &&
                    <button className='g-button small-btn' onClick={() => onDelete(m)}>Delete</button>
                  }
                </div>
              }
            </div>
            <div
              className='news-item-body'
              dangerouslySetInnerHTML={{ __html: linkifyHtml(m.message ?? '', { 'target': '_blank' }) }}></div>
          </div>
        ))
      }
    </div>
  )
}

export default GameNewsList
